import React from 'react';
import logoImage from '../assets/logo.png';
import emailImage from '../assets/email.png';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="py-6 lg:py-8 w-full">
      <div className="w-full">
        {/* Main Footer Content */}
        <div className="grid lg:grid-cols-6 gap-6 lg:gap-10 lg:mb-5 mb-4">
          {/* Left Column - Logo and Description */}
          <div className="lg:col-span-3 space-y-2 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start">
              <img 
                src={logoImage} 
                alt="Vuzo Logo" 
                className="w-[206px]"
              />
            </div>
            <p className="text-[12px] lg:text-[16px] text-gray-300 leading-relaxed max-w-sm mx-auto lg:mx-0">
              Boost productivity and creativity with<br className="hidden md:block" />powerful AI tools. Access GPT-5.4 Pro, Gemini 2.5 Flash,<br className="hidden md:block" /> Claude Sonnet, and more — all in one platform.
            </p>
          </div>

          {/* Right Side - 3 Columns */}
          <div className="lg:col-span-3 grid lg:grid-cols-3 gap-4 text-center lg:text-left">
            {/* Useful Links */}
            <div className="space-y-3">
              <h3 className="text-[15px] font-semibold text-white">Useful Links</h3>
              <ul className="footy space-y-2">
                <li>
                  <a href="/about" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/privacy-notice" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    Privacy Notice
                  </a>
                </li>
                <li>
                  <a href="/terms-of-service" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="/disclaimer" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    Disclaimer
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="/frequently-asked-questions-and-feedback" className="text-[14px] lg:text-[16px] text-[#9e9e9e] hover:text-[#27F5AB] transition-colors">
                    FAQs
                  </a>
                </li>

              </ul>
            </div>

            {/* Contact Info */}
            <div className="space-y-3">
              <h3 className="text-[15px] font-semibold text-white">Contact Info</h3>
              <div className="flex justify-center lg:justify-start">
                <img src={emailImage} className="h-5" alt="email" />
              </div>
            </div>

            {/* Social Media Links */}
            <div className="space-y-3 hidden lg:block">
              <h3 className="text-[15px] font-semibold text-white">Social Media Links</h3>
              <div className="flex space-x-4 justify-center lg:justify-start">
                <a href="https://www.facebook.com/vuzoaiofficial" rel="noreferrer" target="_blank" className="w-8 h-8 rounded-full flex items-center justify-center">
                  <FaFacebookF className="w-5 h-5 text-white" />
                </a>
                <a href="https://www.instagram.com/vuzoai/" rel="noreferrer" target="_blank" className="w-8 h-8 rounded-full flex items-center justify-center">
                  <FaInstagram className="w-5 h-5 text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-[#CDCDCD4A] pt-4">
          <div className="w-full text-center lg:text-left">
            <p className="text-[14px] text-gray-200 mb-3">
              © {new Date().getFullYear()} Vuzo. All rights reserved.
            </p>
            <div className="flex lg:hidden pb-3 justify-center gap-4">
                <a href="https://www.facebook.com/vuzoaiofficial" rel="noreferrer" target="_blank" className="w-8 h-8 rounded-full flex items-center justify-center">
                  <FaFacebookF className="w-4 h-4 text-white" />
                </a>
                <a href="https://www.instagram.com/vuzoai/" rel="noreferrer" target="_blank" className="w-8 h-8 rounded-full flex items-center justify-center">
                  <FaInstagram className="w-4 h-4 text-white" />
                </a>
              </div>
            <p className="text-[11px] text-[#FFFFFF60] leading-[18px]">
              Not affiliated with OpenAI. Information is for general purposes only. See our full{' '}
              <a href="/disclaimer" className="text-[#27F5AB] hover:underline">disclaimer</a>.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
